import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-eligibility-special-inner-tab',
  templateUrl: './eligibility-special-inner-tab.component.html',
  styleUrls: ['./eligibility-special-inner-tab.component.scss']
})
export class EligibilitySpecialInnerTabComponent implements OnInit {
  @Input() tenderId: number;
  @Input() eligibilityList: any;
  eligibilityType: string;
  @Output() valueChange = new EventEmitter();
  constructor() {
    this.eligibilityType = "special";
  }

  ngOnInit() {
    //console.log(this.tenderId)
  }

  getInnerDataTabValue(data: any) {
   // console.log(data)
    this.eligibilityList = data;
    this.valueChange.emit(this.eligibilityList)
  }

}
